<template>
    <div id="datatable-entity_backoffice">
        <v-data-table
            v-model="selected"
            :show-select="isSelectable"
            :headers="headers"
            :items="listaUsers"
            :page="page"
            :pageCount="numberOfPages"
            :options.sync="options"
            :server-items-length="totalItems"
            :footer-props="{
                showFirstLastPage: true,
                'items-per-page-options': [20, 30, 50],
            }"
            dense
            :item-class="itemRowIsCompleted"
            item-key="entityId"
        >
            <template v-slot:[`item.isActive`]="{ item }">
                <v-chip
                    :color="getColor(item.isActive)"
                    pill
                    dark
                    class="status-column"
                >
                    {{ item.isActive }}
                </v-chip>
            </template>
            <template v-slot:[`item.services`]="{ item }">
                <div class="row-services">
                    <div
                        class="p-1 service"
                        v-for="services in item.services"
                        :key="services.moduleId"
                    >
                        <span
                            :title="services.moduleName"
                            data-v-1015cc3e=""
                            :style="`background-color: ${services.moduleColor};`"
                            :class="`services justify-center v-chip theme--dark v-size--default`"
                        >
                            <span class="v-chip__content">
                                {{ services.moduleName.substring(0, 1) }}
                            </span>
                        </span>
                    </div>
                </div>
            </template>
            <template v-slot:[`item.availableAccessTipologies`]="{ item }">
                <div class="row-services">
                    <div
                        class="p-1 service"
                        v-for="(
                            access, index
                        ) in item.availableAccessTipologies"
                        :key="index"
                    >
                        <v-chip
                            :title="access.name"
                            label
                            :style="`background-color: ${access.color};`"
                            class="tipologies theme--dark v-size--default justify-center"
                        >
                            {{ access.name.substring(0, 1) }}
                        </v-chip>
                    </div>
                </div>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip bottom v-if="item.isCompleted">
                    <template v-slot:activator="{ on, attrs }">
                        <span
                            class="mr-2 p-0 circle"
                            :id="item.entityId"
                            @click="onAccountClicked(item)"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <img
                                src="/images/_SVGs/bo/menu-utilizadores-grey.svg"
                                class="circle"
                                onload="SVGInject(this)"
                                width="12"
                                height="12"
                            />
                        </span>
                    </template>
                    <span>{{
                        $t("backoffice.entity-management.user-list")
                    }}</span>
                </v-tooltip>

                <v-tooltip bottom v-if="!item.isCompleted">
                    <template v-slot:activator="{ on, attrs }">
                        <span
                            class="mr-2 p-0 circle"
                            @click="onArchiveClicked(item)"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <img
                                src="/images/_SVGs/trash-can-orange.svg"
                                class="circle"
                                onload="SVGInject(this)"
                                width="12"
                                height="12"
                            />
                        </span>
                    </template>
                    <span>{{
                        item.originalList.entityStatusID == 2
                            ? $t(
                                  "backoffice.entity-management.unarchive-entity"
                              )
                            : $t("backoffice.entity-management.archive-entity")
                    }}</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <span
                            class="mr-2 p-0 circle"
                            @click="onEditClicked(item)"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <img
                                :src="
                                    item.isCompleted
                                        ? '/images/_SVGs/bo/edit_pencil.svg'
                                        : '/images/_SVGs/alert-rhombus.svg'
                                "
                                class="circle"
                                onload="SVGInject(this)"
                                width="12"
                                height="12"
                            />
                        </span>
                    </template>
                    <span
                        >{{
                            item.isCompleted
                                ? $t("backoffice.entity-management.edit")
                                : $t(
                                      "backoffice.entity-management.complete-profile"
                                  )
                        }}
                    </span>
                </v-tooltip>
            </template>
        </v-data-table>
    </div>
</template>

<script>
export default {
    props: {
        listaUsers: Array | Object,
        searchCount: Number,
        totalItems: Number | String,
        isSelectable: Boolean,
        selectedEntities: Array | Object,
    },
    data() {
        return {
            selected: [],
            headers: [
                {
                    text: this.$t("backoffice.entity-management.ref-odoo"),
                    align: "start",
                    value: "odooReference",
                    class: "header-table-color",
                },
                {
                    text: this.$t("backoffice.general.client"),
                    align: "start",
                    value: "comercialName",
                    class: "header-table-color",
                },
                {
                    text: this.$t("backoffice.entity-management.parent-entity"),
                    align: "start",
                    value: "parentName",
                    class: "header-table-color",
                },
                {
                    text: this.$t("backoffice.general.vat"),
                    value: "nif",
                    class: "header-table-color",
                },
                {
                    text: this.$t("backoffice.entity-management.contact-email"),
                    align: "start",
                    value: "email",
                    class: "header-table-color",
                },
                {
                    text: this.$t("backoffice.entity-management.phone"),
                    align: "start",
                    value: "mainTelephone",
                    sortable: false,
                    class: "header-table-color",
                },
                {
                    text: this.$t("backoffice.general.status"),
                    value: "isActive",
                    align: "center",
                    class: "header-table-color",
                },
                {
                    text: this.$t("backoffice.general.services"),
                    value: "services",
                    sortable: false,
                    align: "center",
                },
                {
                    text: this.$t("backoffice.general.access-tipologies"),
                    value: "availableAccessTipologies",
                    sortable: false,
                    align: "center",
                },
                {
                    text: "",
                    value: "actions",
                    sortable: false,
                    align: "right",
                    class: "header-table-color",
                },
            ],
            page: 1,
            numberOfPages: 0,
            options: {
                page: 1,
                itemsPerPage: 20,
            },
        };
    },
    watch: {
        "options.page": {
            handler() {
                this.$store.commit(
                    "backofficeNavigation/setEntitiesCurrentPage",
                    this.options.page
                );
                this.$emit("alterTable", this.options);
            },
        },
        "options.itemsPerPage": {
            handler() {
                this.$store.commit(
                    "backofficeNavigation/setEntitiesPageSize",
                    this.options.itemsPerPage
                );
                this.$emit("alterTable", this.options);
            },
        },
        "options.sortBy": {
            handler() {
                this.$emit("alterTable", this.options);
            },
            immediate: false,
        },
        searchCount: {
            handler() {
                this.options.page = 1;
            },
        },
        selected(newItem) {
            this.$emit("select-export", newItem);
        },
        selectedEntities(newVal) {
            if (newVal.length === 0 && this.selected.length > 0) {
                this.clearSelections();
            }
        },
    },
    methods: {
        getColor(status) {
            if (status == this.$t("backoffice.general.active-status"))
                return "green";
            else if (status == this.$t("backoffice.general.inactive-status"))
                return "red";
            else return "orange";
        },
        getServices(services) {
            let html = "";
            services.map((item) => {
                html += `
            <span data-v-1015cc3e="" class="services v-chip theme--dark v-size--default ${
                item.moduleColor
            }">
                <span class="v-chip__content"> ${item.moduleName.substring(
                    0,
                    1
                )} </span>
            </span>`;
            });
            return html;
        },
        onAccountClicked(item) {
            this.$emit("account-clicked", { item });
        },
        onEditClicked(item) {
            this.$emit("edit-clicked", { item });
        },
        itemRowIsCompleted: function (item) {
            return item.isCompleted ? "" : "bold-style";
        },
        onArchiveClicked(item) {
            this.$emit("archive-clicked", item);
        },
        clearSelections() {
            this.selected = [];
        },
    },
    mounted() {
        const queryParams =
            this.$store.getters["backofficeNavigation/getEntitiesState"];
        this.page = queryParams.currentPage;
        this.options.page = queryParams.currentPage;
        this.options.itemsPerPage = queryParams.pageSize;
        this.options.sortBy = queryParams.sort.sortBy;
        if (queryParams.sort.sortDesc) {
            this.options.sortDesc = queryParams.sort.sortDesc;
        }
    },
};
</script>

<style lang="scss">
@import "@sass/_variables.scss";
#datatable-entity_backoffice {
    .status-column {
        width: 100%;
        margin: 0 auto;
        text-align: center;
        .v-chip__content {
            margin: 0 auto;
            text-align: center;
            font-size: 12px;
        }
    }
    .row-services {
        display: inline-block;
        width: 100px;
        margin: 0 auto;
        @media (max-width: 599px) {
            display: block !important;
        }
        .service {
            display: inline-block;
            @media (max-width: 599px) {
                float: left;
            }
        }
        .services {
            height: 14px !important;
            width: 14px !important;
            border-radius: 50% !important;
            font-size: 10px !important;
            padding: 2px;
        }
        .tipologies {
            height: 14px !important;
            width: 14px !important;
            font-size: 10px !important;
            padding: 2px;
        }
    }

    .circle {
        background-color: #e6e5e5;
        width: 20px;
        height: 20px;
        border-radius: 50%;
    }
    .star {
        color: #ffc117 !important;
    }

    .bold-style {
        font-weight: bold;
    }

    .v-data-footer {
        margin-right: 40px !important;
    }

    thead th .v-simple-checkbox {
        display: none;
    }
}
</style>